import React from 'react';

import { NodeProps, BulletColor } from './shared';
import blackberryBullet from '@/images/blackberry-bullet.svg';
import whiteBullet from '@/images/white-bullet.svg';
import greenBullet from '@/images/green-bullet.svg';

interface UnorderedListNodeProps extends NodeProps {
  bulletColor: BulletColor;
  className?: string;
}

const getBulletImage = (bulletColor: BulletColor): string => {
  switch (bulletColor) {
    case 'black':
      return blackberryBullet.src;
    case 'white':
      return whiteBullet.src;
    case 'green':
    default:
      return greenBullet.src;
  }
};

export function UnorderedListNode({
  children,
  bulletColor
}: UnorderedListNodeProps) {
  const mobileBulletImage = greenBullet.src;
  const tabletBulletImage = getBulletImage(bulletColor);
  const uniqueId = React.useId().replace(/:/g, '');

  return (
    <>
      <style
        dangerouslySetInnerHTML={{
          __html: `
            .unordered-list-${uniqueId} {
              list-style-image: url(${mobileBulletImage});
            }
            @media (min-width: 720px) {
              .unordered-list-${uniqueId} {
                list-style-image: url(${tabletBulletImage});
              }
            }
          `
        }}
      />
      <ul className={`unordered-list-${uniqueId} pl-0 small:pl-6 tablet:pl-0`}>
        {children}
      </ul>
    </>
  );
}
